export { default as Bat } from './component'
